export const getErrorMessage = (error: unknown): string => {
  if (typeof error !== 'object' || error === null) {
    return 'Generic Error';
  }

  if (
    'data' in error &&
    typeof error.data === 'object' &&
    error.data
  ) {
    if ('userMessage' in error.data && typeof error.data.userMessage === 'string') {
      return error.data.userMessage;
    }
    if ('message' in error.data && typeof error.data.message === 'string') {
      return error.data.message;
    }
  }

  if ('error' in error && typeof error.error === 'string') {
    return error.error;
  }

  if ('message' in error && typeof error.message === 'string') {
    return error.message;
  }

  return 'An unknown error occurred';
};